<div class="print-view-container">
  <agr-print-page [showHeaderImage]="false" [showPageNumber]="false">
    <!-- Page 1: Graph -->
    <div class="print-header-main">
      <div class="header-top-row">
        <div class="report-title">
          {{ 'height-measurement.monitoring.print.header-title' | translate }}
        </div>
        <div class="report-date-large">
          {{ reportDateFn() | agrDate: 'mediumDate' }}
        </div>
      </div>
      <div *ngIf="location" class="farm-info">
        <div class="farm-name">{{ location.name }} BP [{{ location.externalId }}]</div>
        <div class="farm-address">
          {{ location.street }} {{ location.houseNumber }}{{ location.houseNumberAddition }},
          {{ location.city }}
        </div>
      </div>
    </div>

    <!-- Selected dates legend -->
    <div class="date-legend" *ngIf="selectedDates && selectedDates.length > 0">
      <div class="legend-title">
        {{ 'height-measurement.monitoring.print.selected-dates' | translate }}:
      </div>
      <div class="legend-items">
        <div class="legend-item" *ngFor="let item of selectedDates">
          <span class="color-indicator" [style.background-color]="item.color"></span>
          <span class="date-text">{{ item.date | agrDate: 'shortDate' }}</span>
        </div>
      </div>
    </div>

    <div class="chart-image-container">
      <img
        *ngIf="chartImageUrl"
        [src]="chartImageUrl"
        alt="Height development chart"
        class="chart-image"
      />
    </div>

    <!-- Page 2: ALVA + Insemination table -->
    <div class="page-break"></div>

    <div class="print-header-main">
      <div class="header-top-row">
        <div class="report-title">{{ 'insemination-advice.print.header-title' | translate }}</div>
        <div class="report-date-large">
          {{ reportDateFn() | agrDate: 'mediumDate' }}
        </div>
      </div>
      <div *ngIf="location" class="farm-info">
        <div class="farm-name">{{ location.name }} BP [{{ location.externalId }}]</div>
        <div class="farm-address">
          {{ location.street }} {{ location.houseNumber }}{{ location.houseNumberAddition }},
          {{ location.city }}
        </div>
      </div>
    </div>

    <div class="alva-metrics-section">
      <h3>{{ 'insemination-advice.print.alva-overview-title' | translate }}</h3>
      <div class="metric-row">
        <span class="metric-title">{{
          'insemination-advice.alva.expected-alva-title' | translate
        }}</span>
        <span class="metric-value">
          <ng-container *ngIf="alvaMetrics?.expectedAlvaMonths != null; else noInfo">
            {{ alvaMetrics.expectedAlvaMonths }}
            {{ 'insemination-advice.alva.months-unit' | translate }}
          </ng-container>
        </span>
      </div>
      <div class="metric-row">
        <span class="metric-title">{{
          'insemination-advice.alva.potential-alva-title' | translate
        }}</span>
        <span class="metric-value">
          <ng-container *ngIf="alvaMetrics?.dairyStartAlvaMonths != null; else noInfo">
            {{ alvaMetrics.dairyStartAlvaMonths }}
            {{ 'insemination-advice.alva.months-unit' | translate }}
          </ng-container>
        </span>
      </div>
      <div class="metric-row">
        <span class="metric-title">{{
          'insemination-advice.alva.phosphate-title' | translate
        }}</span>
        <span class="metric-value">
          <ng-container *ngIf="alvaMetrics?.phosphateDifferenceKg != null; else noInfo">
            {{ alvaMetrics.phosphateDifferenceKg }}
            {{ 'insemination-advice.alva.kg-unit' | translate }}
          </ng-container>
        </span>
      </div>

      <ng-template #noInfo>{{ 'insemination-advice.alva.no-information' | translate }}</ng-template>
    </div>

    <hr />

    <table class="print-table">
      <thead>
        <tr>
          <th>{{ 'insemination-advice.columns.animal-id' | translate }}</th>
          <th>{{ 'insemination-advice.columns.ear-number' | translate }}</th>
          <th>{{ 'insemination-advice.columns.name' | translate }}</th>
          <th>{{ 'insemination-advice.columns.age' | translate }}</th>
          <th>{{ 'insemination-advice.columns.height' | translate }}</th>
          <th>{{ 'insemination-advice.columns.estimated-height' | translate }}</th>
          <th>{{ 'insemination-advice.columns.last-insemination' | translate }}</th>
          <th>{{ 'insemination-advice.columns.advice' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of printTableDataFn()" [ngClass]="row.className">
          <td>{{ row.number }}</td>
          <td>{{ row.earNumber }}</td>
          <td>{{ row.name }}</td>
          <td>{{ row.ageInMonths | number: '1.1-1' }} mnd.</td>
          <td>{{ row.hipHeight }}</td>
          <td>{{ row.estimatedHipHeight }}</td>
          <td>{{ row.lastInsemination ? (row.lastInsemination | agrDate: 'shortDate') : '' }}</td>
          <td>{{ row.advice }}</td>
        </tr>
      </tbody>
    </table>

    <!-- Page 3: Stall list height measurement -->
    <div class="page-break"></div>

    <div class="print-header-main">
      <div class="header-top-row">
        <div class="report-title">
          {{ 'height-measurement.monitoring.print.stall-list-title' | translate }}
        </div>
      </div>
      <div *ngIf="location" class="farm-info">
        <div class="farm-name">{{ location.name }} BP [{{ location.externalId }}]</div>
        <div class="farm-address">
          {{ location.street }} {{ location.houseNumber }}{{ location.houseNumberAddition }},
          {{ location.city }}
        </div>
      </div>
    </div>

    <div class="stall-list-date-label">
      {{ 'height-measurement.monitoring.print.stall-list-last-measurement' | translate }}:
      <strong>{{ stallListDate | agrDate: 'mediumDate' }}</strong>
    </div>

    <hr />

    <table class="print-table">
      <thead>
        <tr>
          <th>{{ 'height-measurement.table.registrationNumber' | translate }}</th>
          <th>{{ 'height-measurement.table.earNumber' | translate }}</th>
          <th>{{ 'height-measurement.table.name' | translate }}</th>
          <th>{{ 'height-measurement.table.dateOfBirth' | translate }}</th>
          <th>{{ 'height-measurement.table.ageInMonths' | translate }}</th>
          <th>{{ 'height-measurement.table.hipHeight' | translate }}</th>
          <th>{{ 'height-measurement.table.bcs' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of stallListCowMeasurements">
          <td>{{ row.registrationNumber }}</td>
          <td>{{ row.earNumber }}</td>
          <td>{{ row.name }}</td>
          <td>{{ row.dateOfBirth | agrDate: 'shortDate' }}</td>
          <td>{{ row.ageInMonths }}</td>
          <td>{{ row.heightCm }}</td>
          <td>{{ row.bodyConditionScore }}</td>
        </tr>
      </tbody>
    </table>
  </agr-print-page>

  <div class="print-logo-lastpage">
    <div class="logo-container" *ngIf="showLogo">
      <img src="assets/img/agrifirm-logo.png" alt="Agrifirm" (error)="onLogoError()" />
    </div>
  </div>
</div>
